import React from "react";
import { Table, Rate } from "antd";
import type { ColumnsType } from "antd/es/table";
import WidgetDrawer from "./WidgetDrawer";
import {
    IOtherSellersDataModalWidgetProps,
    TOtherSellerFormattedData,
} from "@/ts/common-types";

const columns: ColumnsType<TOtherSellerFormattedData> = [
    {
        title: "Seller",
        dataIndex: "seller",
        key: "seller",
        render: (text) => <a href="#">{text}</a>,
    },
    {
        title: "Rating & Reviews",
        key: "ratingReviews",
        render: (_, record) => (
            <div>
                <Rate disabled defaultValue={record.rating} />{" "}
                <span>
                    ({record.review} ratings) {record.positiveFeedback}%
                    positive
                </span>
            </div>
        ),
    },
    {
        title: "Discounted Price",
        dataIndex: "discountedPrice",
        key: "discountedPrice",
        render: (text) => (
            <span style={{ color: "red", fontWeight: "bold" }}>{text}</span>
        ),
    },
    {
        title: "M.R.P",
        dataIndex: "mrp",
        key: "mrp",
        render: (text) => (
            <span style={{ textDecoration: "line-through", color: "gray" }}>
                {text}
            </span>
        ),
    },
    {
        title: "Delivery Date",
        dataIndex: "deliveryDate",
        key: "deliveryDate",
    },
];

const OtherSellersDataModalWidget: React.FC<
    IOtherSellersDataModalWidgetProps
> = ({ title, show, setShow, widgetData }) => {
    return (
        <WidgetDrawer
            title={title}
            width="85vw"
            show={show}
            onClose={() => {
                setShow(false);
            }}
            bodyStyle={{ backgroundColor: "#FFFFFF" }}
        >
            <Table
                columns={columns}
                dataSource={widgetData}
                pagination={false}
            />
        </WidgetDrawer>
    );
};

export default OtherSellersDataModalWidget;
